  <div *ngIf="showModal" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
    (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div [ngClass]='{"modal-lg modal-dialog-scrollable": modalType === "viewAll"}' class="custom-theme-modal modal-dialog modal-md modal-dialog-centered"
      role="document">
      <div class="modal-content">
        <div class="modal-header d-block p-3"  *ngIf="title !=='subscribe'">
          <div class="row">
            <div class="col-9 pr-0">
              <p class="heading-4">
                <img *ngIf="modalType === 'viewAll'" class="mr-3 border edetail-modal-logo" alt="modal-logo"
                [src]='logo' onerror="this.src='assets/themes/icons/profilepic.svg'"> 
                <span class="color-grey-700">{{title}}</span>
              </p>
            </div>
            <div class="col-3 pr-3 text-right">
              <span id="Drug_modal_closes-index-10  " class="cursor-pointer cross-btn-index relative" (click)="onHidden()">
                <img src="assets/themes/icons/cancel.svg" alt="cross">
              </span>
            </div>
          </div>
        </div>
        <div class="modal-body"  [ngClass]="{'px-3':callingFrom === screenName.GRAND_ROUND}">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>